import { validators } from './validators';

export const validateAddress = (data) => {
  const errors = {};

  // Label
  if (!data.label) {
    errors.label = 'Address type is required';
  }

  // Full name
  errors.full_name = validators.name(data.full_name, 'Full name');

  // Phone
  errors.phone = validators.phone(data.phone, true);

  // Address line 1
  if (!data.address_line1?.trim()) {
    errors.address_line1 = 'Address is required';
  } else if (data.address_line1.length > 200) {
    errors.address_line1 = 'Address must not exceed 200 characters';
  }

  // Address line 2 (optional)
  if (data.address_line2 && data.address_line2.length > 200) {
    errors.address_line2 = 'Address line 2 must not exceed 200 characters';
  }

  // City
  if (!data.city?.trim()) {
    errors.city = 'City is required';
  } else if (data.city.length > 100) {
    errors.city = 'City must not exceed 100 characters';
  }

  // State
  if (!data.state?.trim()) {
    errors.state = 'State is required';
  } else if (data.state.length > 100) {
    errors.state = 'State must not exceed 100 characters';
  }

  // Postal code
  errors.postal_code = validators.pincode(data.postal_code);

  // Country
  if (!data.country?.trim()) {
    errors.country = 'Country is required';
  }

  // Filter out null errors
  const filtered = Object.entries(errors)
    .filter(([_, v]) => v)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});

  return {
    isValid: Object.keys(filtered).length === 0,
    errors: filtered,
  };
};

export const validatePasswordChange = (currentPassword, newPassword, confirmPassword) => {
  const errors = {};

  if (!currentPassword) {
    errors.current_password = 'Current password is required';
  }

  errors.new_password = validators.password(newPassword);

  errors.confirm_password = validators.confirmPassword(confirmPassword, newPassword);

  const filtered = Object.entries(errors)
    .filter(([_, v]) => v)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});

  return {
    isValid: Object.keys(filtered).length === 0,
    errors: filtered,
  };
};